import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FilterButton } from 'src/components/FilterButton/FilterButton';
import { getDesks, getDesksFiltersCount } from 'src/store/desks/selectors';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const DeskBookingFilterButton: FC = () => {
  const dispatch = useAppDispatch();
  const filtersCount = useSelector(getDesksFiltersCount);
  const hasItemsToFilter = !!useSelector(getDesks).size;

  const open = useCallback(() => {
    dispatch(sidesheetActions.open('desksFilters'));
  }, [dispatch]);

  return (
    <FilterButton
      onClick={open}
      filtersCount={filtersCount}
      disabled={!hasItemsToFilter}
      testId='deskBookingFilterButton'
    />
  );
};
